export const getDigits = (value: string) => (value ? value.replace(/[^\d]+/g, "") : "");
